/**
 * `bstockFee` is in cents, `basis` in dollars, so the ratio numerically
 * reconstructs the seller's buyer's-premium percentage (e.g. 650 / 100 =
 * 6.5). Round to 2 decimal places rather than the nearest integer — the
 * premium itself can carry 2 decimal places, and rounding to a whole number
 * misrepresents e.g. 6.5% as 7%.
 */
export const calculateFeePercent = (
  bstockFee: number,
  basis: number
): number => (basis > 0 ? Math.round((bstockFee / basis) * 100) / 100 : 0)
